export default {
    methods: {
        parseMarkup(value) {
            // Encode tags so they are not executed
            let result = value.replace('<', '&lt;').replace('>', '&gt;');

            result = this.parseMarkupLines(result);
            result = this.parseMarkupLinks(result);

            return result;
        },

        parseMarkupLines(value) {
            let result = '';
            let isList = false;
            const parts = value.replace('\r\n', '\n').replace('\r', '\n').split('\n');

            parts.forEach((line) => {
                if (line.match(/^ ?-.+$/)) {
                    if (!isList) {
                        result += '<ul>\n';
                        isList = true;
                    }

                    result += line.replace(/^ ?-(.+)$/, '<li>$1</li>\n');
                } else {
                    if (isList) {
                        result += '</ul>\n';
                        isList = false;
                    }

                    result += `${line}<br>\n`;
                }
            });

            if (isList) {
                result += '</ul>';
            }

            return result;
        },

        parseMarkupLinks(value) {
            return value.replace(/((https?:\/\/|www.)[^\s]+)/i, (match, p1) => {
                const link = p1 === 'www.' ? `http://${match}` : match;

                return `<a href="${link}" target="_blank">${match}</a>`;
            });
        },

        parseNewlines(value) {
            return value.replace('\n', '\n<br>');
        },
    },
};
